import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AssetVersionPipe} from '../../../../pipes/asset-version.pipe';
import {StateService} from '../../../../services/state.service';
import {PolarisRoutePaths, RoutePaths} from '../../../../shared/types/common';
import {PosthogService} from '../../../../services/posthog.service';
import {PosthogEventName} from '../../../../services/types';

export interface ShareChatModalData {
  chatId: string;
}

@Component({
  selector: 'app-share-chat-modal',
  standalone: true,
  imports: [AssetVersionPipe],
  templateUrl: './share-chat-modal.component.html',
  styleUrl: './share-chat-modal.component.scss'
})
export class ShareChatModalComponent {
  private dialogRef = inject(MatDialogRef<ShareChatModalComponent>);
  private stateService = inject(StateService);
  private posthogService = inject(PosthogService);
  private data = inject<ShareChatModalData>(MAT_DIALOG_DATA);

  public copied = false;
  private copyResetTimeout?: ReturnType<typeof setTimeout>;

  public readonly shareUrl =
    `${window.location.origin}/${RoutePaths.POLARIS}/${PolarisRoutePaths.CHAT}/${PolarisRoutePaths.SHARED}/${this.data.chatId}`;
  public readonly displayUrl = this.shareUrl.replace(/^https?:\/\//, '');
  public readonly accountName = this.resolveAccountName();

  public close(): void {
    this.dialogRef.close();
  }

  public async copyLink(): Promise<void> {
    this.posthogService.capture(PosthogEventName.SHARE_LINK_COPIED);
    try {
      await navigator.clipboard.writeText(this.shareUrl);
    } catch {
      throw new Error('failed to copy chat, please try again.');
    }
    this.copied = true;
    clearTimeout(this.copyResetTimeout);
    this.copyResetTimeout = setTimeout(() => (this.copied = false), 2200);
  }

  private resolveAccountName(): string {
    const key = this.stateService.activeAccount();
    return this.stateService.accounts.find(account => account.key === key)?.name ?? key;
  }
}
